<template src="./template.html"></template>
<style lang="scss" src="./styles.scss"></style>

<script setup>
import BaseModal from '@/components/BaseModal/index.vue'

const props = defineProps({
  modelValue: Boolean,
  title: {
    type: String,
    default: "Confirm Action",
  },
  message: {
    type: String,
    default: "Are you sure?",
  },
  confirmText: {
    type: String,
    default: "Confirm",
  },
  cancelText: {
    type: String,
    default: "Cancel",
  },
})

const emit = defineEmits(["update:modelValue", "confirm", "cancel"])

function onConfirm() {
  emit("confirm")
  emit("update:modelValue", false)
}
</script>
